import * as type from "../types";

const initialState = {
  selectedToOrganization: {},
  certificates: {
    activeList: [],
    activeLoading: false,
    activeError: false,
  },
  list: [],
  loading: false,
  error: false,
  historyList: [],
  filters: {
    selectedSellerOrganization: {},
    selectedBuyerOrganization: {},
    selectedDateWithOrganization: {},
  },
  historyLoading: false,
  historyError: false,
};

const bilateralAgreements = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_SELECTED_TO_ORGANIZATION:
      return {
        ...state,
        selectedToOrganization: action.payload,
      };
    case type.GET_CERTIFICATES_REQUEST:
      return {
        ...state,
        certificates: {
          ...state.certificates,
          activeLoading: true,
          activeError: false,
        },
      };
    case type.GET_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        certificates: {
          activeList: action.payload.items,
          total: action.payload.total,
          activeLoading: false,
          activeError: false,
          documentCount: action.payload.documentCount,
          blockedDocumentCount: action.payload.blockedDocumentCount,
        },
      };
    case type.GET_CERTIFICATES_FAILED:
      return {
        ...state,
        certificates: {
          ...state.certificates,
          activeLoading: false,
          activeError: true,
        },
      };
    case type.GET_BILATERAL_AGREEMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_BILATERAL_AGREEMENTS_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_BILATERAL_AGREEMENTS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST:
      return {
        ...state,
        historyLoading: true,
        historyError: false,
      };
    case type.GET_BILATERAL_AGREEMENTS_HISTORY_SUCCEEDED:
      return {
        ...state,
        historyList: action.payload.dataList,
        total: action.payload.total,
        sellerTotal: action.payload.sellerTotal,
        buyerTotal: action.payload.buyerTotal,
        historyLoading: false,
        historyError: false,
      };
    case type.GET_BILATERAL_AGREEMENTS_HISTORY_FAILED:
      return {
        ...state,
        historyLoading: false,
        historyError: true,
      };
    case type.SET_SELECTED_SELLER_ORGANIZATION:
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedSellerOrganization: action.payload,
        },
      };
    case type.SET_SELECTED_DATE_WITH_ORGANIZATION:
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedDateWithOrganization: action.payload,
        },
      };
    case type.SET_SELECTED_BUYER_ORGANIZATION:
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedBuyerOrganization: action.payload,
        },
      };
    default:
      return state;
  }
};

export default bilateralAgreements;
